import { temAcesso } from '@/shared/auth/temAcesso'

const TiposMovimentos = () => import('./TiposMovimentos.vue')
const TiposMovimentosForm = () => import('./TiposMovimentosForm.vue')

export default {
    path: 'tiposmovimentos',
    name: 'TiposMovimentos',
    component: TiposMovimentos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('ADMIN-TIPMOV-00')) {
            next()
        }
    },
    children: [
        {
            path: 'inserir',
            name: 'TiposMovimentos_Inserir',
            component: TiposMovimentosForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('ADMIN-TIPMOV-01')) {
                    next()
                }
            }
        },
        {
            path: ':codMov',
            name: 'TiposMovimentos_Detalhar',
            component: TiposMovimentosForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('ADMIN-TIPMOV-00')) {
                    next()
                }
            }
        }
    ]
}
